import React from 'react';
import { Layout, Skeleton } from 'antd';

const { Content } = Layout;

const ShimmerSkeleton = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout className="site-layout">
        <Content style={{ margin: '24px 16px',marginTop:"4rem", padding: 24, background: '#fff' }}>
          <Skeleton active />
        </Content>
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff' }}>
          <Skeleton active />
        </Content>
      </Layout>
      
    </Layout>
  );
};

export default ShimmerSkeleton;
